import { render, staticRenderFns } from "./codeExample.vue?vue&type=template&id=3f8089e0&"
import script from "./codeExample.vue?vue&type=script&lang=js&"
export * from "./codeExample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports